import { PageAttribute } from 'aa/vue/components/account/PageAttribute';
import AccountPageTrackingService from 'aa/services/AccountPageTrackingService';
import { ACCOUNT_XHR_BASE_PATH } from 'aa/vue/constants/aaRoutes';
import NotificationMixin from "aa/vue/plugins/NotificationMixin";

export default {
    data() {
        return {
            token: this.$store
                ? this.$store.getters.getServerDataByKey('authToken')
                : null,
            trackActionName: AccountPageTrackingService.actionName
        };
    },
    mixins: [NotificationMixin],
    filters: {
        datarole(value) {
            if (value && value.length > 0) {
                return value.toLowerCase().replace(/\s/g, '-');
            }

            return '';
        }
    },
    computed: {
        user() {
            return this.$store ? this.$store.state.user : null;
        },
        pageAttribute() {
            let fromStore = this.$store
                ? this.$store.state[this.$route.name].pageAttributes
                : null;
            return new PageAttribute(
                fromStore.hasOwnProperty(this.$options.name)
                    ? fromStore[this.$options.name]
                    : null
            );
        },

        cmsImageBasePath() {
            if (typeof this.$store.state.serverData.cmsImageHost !== 'undefined') {
                return this.$store.state.serverData.cmsImageHost + '/base/'
            } else if (typeof this.$root.serverData.cmsImageHost !== 'undefined') {
                return this.$root.serverData.cmsImageHost + '/base/';
            }

            return null;
        }
    },
    methods: {
        buildHttpData(rawData) {
            let result = {
                tk_trp: this.token
            };

            Object.assign(result, rawData);

            // Add recaptcha action in the httpData
            if (this.hasOwnProperty('recaptchaAction')) {
                result.recaptchaAction = this.recaptchaAction;
            }

            return result;
        },
        closeModal() {
            this.$store.dispatch('modal/setIsShown', false);
        },
        openModal(modalName) {
            this.$store.dispatch('modal/setModal', modalName);
        },
        syncServerData() {
            this.$http
                .doGet(`${ACCOUNT_XHR_BASE_PATH}fetch-subscription-data/`)
                .then((res) => {
                    this.$store.dispatch('syncServerData', res.data.result);
                });
        },

        matchesShowtimeSku(productCode) {
            let regex = new RegExp(
                '(PPLUS_LCP|AA_CF)_SHO_(TRIAL_)?(MONTHLY|ANNUAL)'
            );

            return regex.test(productCode);

        }
    }
};
